import { PtcldScriptContextProvider, usePtcldScriptContext } from "../../../../contexts/PtcldScriptContext";

import PointCloudViewerContent from "../PointCloudViewerContent/PointCloudViewerContent";
import { useSearchParams } from "react-router-dom";
import { useGetScanQuery } from "api/scan/queries/useGetScanQuery";

type Props = {
  pointCloudData: PointCloudOutput | undefined;
  dataError: Error | null;
  isUniScan? :string;
};

export default function PointCloudViewer({ pointCloudData, dataError,isUniScan }: Props) {
  return (
    <PtcldScriptContextProvider>
      <PointCloudViewerContent pointCloudData={pointCloudData} dataError={dataError} />
    </PtcldScriptContextProvider>
  );
}
